import { Inter } from 'next/font/google'
import localFont from 'next/font/local'

export const inter = Inter({
	subsets: ['latin'],
	display: 'swap',
	preload: true,
	fallback: ['system-ui'],
})

export const localInter = localFont({
	src: '../../public/fonts/Inter-VariableFont_opsz,wght.ttf',
	weight: '400',
	style: 'normal',
	display: 'swap',
})

export default inter
